/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Logout_CrumbInputs */

const en_auth_logout_crumb = /** @type {(inputs: Auth_Logout_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout`)
};

/**
* | output |
* | --- |
* | "Logout" |
*
* @param {Auth_Logout_CrumbInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_logout_crumb = /** @type {((inputs?: Auth_Logout_CrumbInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Logout_CrumbInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_logout_crumb(inputs)
});